import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { PeopleTwoIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createPcrPayScale } from '../../api/pcr-pay-scale/create-pcr-pay-scale'
import UserNavBar from '../../components/elements/nav-bar'
import { PcrPayScaleForm } from '../../components/pages/pcr-pay-scale/pcr-pay-scale-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const PcrPayScaleCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createPcrPayScale,
    onError: showAxiosError,
    onSuccess: () => toast.success('Barème de rémunération créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un nouveau Barèmes de rémunération'} icon={PeopleTwoIcon} />
      <div className="h-4" />
      <Box>
        <div className="flex justify-between items-center py-2">
          <div className="flex items-center gap-4">
            <Typography variant="sub-heading">Barèmes de rémunération</Typography>
          </div>
        </div>
        <div className="h-5" />
        <PcrPayScaleForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.PCR_PAY_SCALE_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back(Paths.PCR_PAY_SCALES)
          })}
        />
      </Box>
    </div>
  )
}

export default PcrPayScaleCreatePage
